/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavItem_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNav_navigation$ref: FragmentReference;
export type SiteNav_navigation = {|
  +modules: ?$ReadOnlyArray<?{|
    +serviceId: ?string,
    +name: ?string,
    +url: ?string,
    +visible: ?boolean,
    +isHighlighted: ?boolean,
    +items: ?$ReadOnlyArray<?{|
      +serviceId: ?string,
      +name: ?string,
      +type: ?string,
      +column: ?string,
      +items: ?$ReadOnlyArray<?{|
        +serviceId: ?string,
        +name: ?string,
        +url: ?string,
        +visible: ?boolean,
      |}>,
    |}>,
    +$fragmentRefs: SiteNavItem_navigationModule$ref,
  |}>,
  +$refType: SiteNav_navigation$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "visible",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SiteNav_navigation",
  "type": "Navigation",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "modules",
      "storageKey": null,
      "args": null,
      "concreteType": "NavigationModule",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isHighlighted",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SiteNavItem_navigationModule",
          "args": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "NavigationTopLevel",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "column",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "NavigationItem",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'edad5a0f97e880088b8f8351e4283138';
module.exports = node;
